import { api } from "./httpClient";
import type {
  TradingBotConfig,
  UpdateTradingBotPayload,
  CreateTradingBotPayload,
  TradingBotHistoryEntry,
} from "../types/api";

export async function getConfigs(): Promise<{
  configs: TradingBotConfig[];
  maxTradingBots: number;
}> {
  const res = await api<{ configs: TradingBotConfig[]; maxTradingBots: number }>({
    method: "GET",
    url: "/trading-bot",
  });
  const data = res.data.data;
  return {
    configs: data?.configs ?? [],
    maxTradingBots: data?.maxTradingBots ?? 1,
  };
}

export async function getConfig(id: number): Promise<{ config: TradingBotConfig }> {
  const res = await api<{ config: TradingBotConfig }>({
    method: "GET",
    url: `/trading-bot/${id}`,
  });
  return res.data.data;
}

export async function createConfig(
  payload: CreateTradingBotPayload
): Promise<{ config: TradingBotConfig }> {
  const res = await api<{ config: TradingBotConfig }>({
    method: "POST",
    url: "/trading-bot",
    data: payload,
  });
  return res.data.data;
}

export async function updateConfig(
  id: number,
  payload: UpdateTradingBotPayload
): Promise<{ config: TradingBotConfig }> {
  const res = await api<{ config: TradingBotConfig }>({
    method: "PUT",
    url: `/trading-bot/${id}`,
    data: payload,
  });
  return res.data.data;
}

export async function deleteConfig(id: number): Promise<{ deleted: boolean }> {
  const res = await api<{ deleted: boolean }>({
    method: "DELETE",
    url: `/trading-bot/${id}`,
  });
  return res.data.data;
}

export interface StrategyDefault {
  type: string;
  label: string;
  params: Record<string, number | string>;
}

export async function getDefaults(): Promise<{
  strategies: Array<{ type: string; label: string; params: Record<string, number | string> }>;
}> {
  const res = await api<{
    strategies: Array<{ type: string; label: string; params: Record<string, number | string> }>;
  }>({
    method: "GET",
    url: "/trading-bot/defaults",
  });
  return res.data.data;
}

export async function getHistory(
  limit?: number,
  offset?: number
): Promise<{ history: TradingBotHistoryEntry[]; total: number }> {
  const params = new URLSearchParams();
  if (limit != null) params.set("limit", String(limit));
  if (offset != null) params.set("offset", String(offset));
  const qs = params.toString();
  const res = await api<{ history: TradingBotHistoryEntry[]; total: number }>({
    method: "GET",
    url: `/trading-bot/history${qs ? `?${qs}` : ""}`,
  });
  return res.data.data;
}

export async function runMyBots(): Promise<{ executed: number; errors: number }> {
  const res = await api<{ executed: number; errors: number }>({
    method: "POST",
    url: "/trading-bot/run",
  });
  return res.data.data;
}
